module.exports = __webpack_public_path__ + "img/mask5.bec78c78.png";